<form [formGroup]="form" novalidate>
    <div d-flex align-items-end flex-column>
        <div class="modal-header">
            <h4 class="modal-title" *ngIf="mode === modelPopupMode?.tradeExecuted">ADD EXECUTED TRADE :
                {{tradeSimulation?.modelName}}</h4>
            <h4 class="modal-title" *ngIf="mode === modelPopupMode?.create">NEW MODEL : {{legalEntityName}}</h4>
            <h4 class="modal-title" *ngIf="mode === modelPopupMode?.edit">EDIT MODEL :
                {{tradeSimulation?.modelName}}</h4>
            <h4 class="modal-title" *ngIf="mode === modelPopupMode?.view">VIEW MODEL :
                {{tradeSimulation?.modelName}}</h4>
            <span class="logo-btn-small close white" (click)="activeModal.dismiss('Cross click')"></span>
        </div>
        <div class="d-flex flex-row px-p-10 px-py-5 bg-yellow" *ngIf="mode === modelPopupMode?.tradeExecuted">
            <em class="material-icons md-18">error</em>
            <span class="px-ml-5">Please add the P&L Account Values and Accounting Values</span>
        </div>
        <div *ngIf="dataLoading" class="px-p-20 font-weight-bold"> Data loading, please wait...</div>
        <div *ngIf="!dataLoading" >
            <div class="px-px-10">
                <div class="d-flex flex-row px-py-20">
                    <div>Model name: </div>
                    <div class="flex-fill px-ml-5">
                        <div class=" w-50" [class.error]="!form.get('modelName').valid && form.get('modelName').dirty">
                            <input class="form-control form-control-sm" type="text" autofocus formControlName="modelName"
                                   [class.readonly-input]="mode ===  modelPopupMode?.view">
                            <div class="triangle" *ngIf="!form.get('modelName').valid && form.get('modelName').dirty">
                                <div class="error-message">
                                    <div *ngIf="form.get('modelName').hasError('required')">Required</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-body d-flex flex-column scroll-y"
                 [class.trade-executed-mode]="mode === modelPopupMode?.tradeExecuted">
                <app-model-instrument
                    *ngFor="let item of instruments?.controls; let index = index; let first = first;"
                    [instrumentItemFormGroup]="item"
                    [mode]="mode"
                    [index]="instruments?.controls.length>1?2:0"
                    (removeInstrument)="onRemoveInstrument(index)"
                    [class.px-mt-10]="!first">
                </app-model-instrument>
                <div class="px-px-10 px-mt-10" *ngIf="mode !== modelPopupMode?.view">
                    <button class="btn btn-sm btn-basic" (click)="addNewInstrument()">
                        ADD ANOTHER INSTRUMENT
                    </button>
                </div>
                <div class="px-pt-10 px-mx-10" *ngIf="tradeSimulation?.tradeExecuted || mode === modelPopupMode?.tradeExecuted">
                    <div formArrayName="counterpartyTradeValues" class="d-flex flex-column table-by-row custom-table">
                        <div class="d-flex flex-row">
                            <div class="px-w-100"> Counter party</div>
                            <div class="px-w-100"> Accounting value</div>
                        </div>
                        <ng-template ngFor let-item [ngForOf]="counterpartyTradeValues?.controls" let-i="index">
                            <div class="d-flex flex-row" [formGroupName]="i">
                                <div class="px-w-100">
                                    {{item.value.counterParty}}
                                </div>
                                <div class="px-w-100 trade-executed-column">
                                    <input class="form-control form-control-sm" type="text" formControlName="accountingValue"
                                    [class.readonly-input]="mode ===  modelPopupMode?.view">
                                </div>
                            </div>
                        </ng-template>
                    </div>
                </div>
            </div>

            <div class="modal-footer mt-auto">
                <button type="button" class="btn btn-sm btn-basic" (click)="activeModal.dismiss()" *ngIf="mode !== modelPopupMode?.view">CANCEL</button>
                <button type="button" class="btn btn-sm btn-basic" (click)="activeModal.dismiss()" *ngIf="mode === modelPopupMode?.view">CLOSE</button>
                <button type="button" class="btn btn-sm btn-basic" (click)="deleteModel()"
                        *ngIf="mode === modelPopupMode?.edit || mode === modelPopupMode?.tradeExecuted">DELETE
                </button>
                <button type="button" class="btn btn-sm btn-basic" [class.bnpp-btn]="mode === modelPopupMode?.tradeExecuted"
                        (click)="tradeExecuted()"
                        *ngIf="!tradeSimulation?.tradeExecuted && mode !== modelPopupMode?.view">
                    {{(!tradeSimulation?.tradeExecuted && mode !== modelPopupMode?.tradeExecuted) ? 'TRADE EXECUTED' :
                    'ADD EXECUTED TRADE'}}
                </button>
                <button type="button" class="btn btn-sm btn-basic bnpp-btn px-w-75" (click)="saveModel()"
                        *ngIf="mode === modelPopupMode?.edit || mode === modelPopupMode?.create" [disabled]="!form.valid">
                    SAVE
                </button>
            </div>
        </div>

    </div>
</form>

